// API适配器 - 将现有API适配为流程设计器需要的格式
import { getUserList, getSimpleUserList } from '../user'

function unwrapPayload(response) {
  return response?.data || response || {}
}

function normalizePage(response) {
  const payload = unwrapPayload(response)
  const records = payload.records || payload.list || (Array.isArray(payload) ? payload : [])
  return {
    records,
    total: Number(payload.total ?? payload.totalCount ?? records.length ?? 0),
    page: Number(payload.current ?? payload.page ?? 1),
    size: Number(payload.size ?? records.length ?? 0)
  }
}

/**
 * 获取用户列表 (适配器)
 * @param {object|Array} params - 分页查询参数，兼容旧的用户名数组过滤
 * @returns {Promise}
 */
export async function getList(params = {}) {
  try {
    const usernameFilter = Array.isArray(params) ? params : null
    let response
    if (usernameFilter) {
      response = await getSimpleUserList({})
    } else {
      response = await getSimpleUserList(params)
    }
    const page = normalizePage(response)
    
    // 适配返回格式
    let data = page.records
    
    // 如果传入了usernames，则过滤
    if (usernameFilter && usernameFilter.length > 0) {
      data = data.filter(user => usernameFilter.includes(user.username))
    }
    
    return {
      success: true,
      data: data,
      total: page.total,
      page: page.page,
      size: page.size
    }
  } catch (error) {
    console.error('获取用户列表失败:', error)
    return {
      success: false,
      data: []
    }
  }
}

/**
 * 根据用户名获取用户信息
 * @param {string} username - 用户名
 * @returns {Promise}
 */
export async function getByUsername(username) {
  try {
    // 尝试通过列表接口查找
    const response = await getUserList({ username, page: 1, size: 10 })
    const users = normalizePage(response).records
    
    const user = users.find(u => u.username === username) || users[0]
    
    return {
      success: true,
      data: user || { username, name: username, avatar: '' }
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
    return {
      success: false,
      data: { username, name: username, avatar: '' }
    }
  }
}
